export const knmChecklistTemplatesGetBasicParams = {
  needQuestions: true,
  size: '2000',
};
